import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[600px] md:h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20Chinese%20scene%20with%20soft%20golden%20morning%20light%20streaming%20through%20traditional%20window%20lattice%2C%20delicate%20hands%20gently%20cradling%20a%20glowing%20object%2C%20ink%20wash%20painting%20style%20blurred%20background%20with%20subtle%20mountain%20and%20cloud%20motifs%2C%20serene%20and%20emotional%20atmosphere%2C%20muted%20warm%20earth%20tones%20with%20cream%20and%20amber%20highlights%2C%20ethereal%20and%20poetic%20composition%2C%20cultural%20heritage%20aesthetic%20with%20modern%20minimalism&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="掌中的美母 - 温暖与力量的邂逅"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-4xl mx-auto">
        <p className="text-sm md:text-base text-background-100/90 tracking-widest mb-4 font-label">
          探索内在之美 · 感受温暖力量
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-6 leading-tight">
          掌中的美母
        </h1>
        <p className="text-base md:text-lg text-background-100/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          全方位呈现掌中的美母的核心价值、使用场景与真实体验，
          助您深入了解每一个细节，发现属于您的<strong>专属感受</strong>。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/core-value"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors duration-300 whitespace-nowrap"
          >
            探索核心价值
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}